type Props = { size?: number };

export function StitchedPMark({ size = 48 }: Props) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: 'var(--forest)',
        border: `${Math.max(2, size * 0.06)}px solid var(--ink)`,
        boxShadow: `inset 0 0 0 ${Math.max(1.5, size * 0.04)}px var(--cream)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        flexShrink: 0,
      }}
    >
      <span
        style={{
          fontFamily: 'Bevan',
          color: 'var(--cream)',
          fontSize: size * 0.5,
          letterSpacing: '0.02em',
          textShadow: '1px 1px 0 rgba(0,0,0,0.3)',
          marginTop: -2,
        }}
      >
        P
      </span>
      <div
        style={{
          position: 'absolute',
          inset: size * 0.12,
          borderRadius: '50%',
          border: '1px dashed rgba(241,231,208,0.4)',
          pointerEvents: 'none',
        }}
      />
    </div>
  );
}
